// src/components/Slider.jsx
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./slider.css";

function Slider() {
  const { user } = useContext(AuthContext);
  const targetLink = user ? "/mi-cuenta" : "/login";

  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">¡IMPULSA TU FUTURO!</h1>
        <p className="hero-subtitle">
          Conectamos a la comunidad latina con temas de empleos, asesoría, educación, emprendimiento y migración.
        </p>
        <p className="hero-subtitle">
          Crea una cuenta y obtén resultados personalizados.
        </p>
        <div className="hero-buttons">
          <Link to={targetLink} className="btn slider-button">
            INICIA AHORA
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Slider;